export default __webpack_public_path__ + "static/SRUS YT25 - Product Specifications & Technical Data-0da31ee80605d292b825f89e30d3e4e5.pdf";